/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { FibonacciHeapDependencies } from './dependenciesFibonacciHeapClass.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { createSpaClass } from '../../factoriesAny.js';
export var SpaDependencies = {
  FibonacciHeapDependencies: FibonacciHeapDependencies,
  addScalarDependencies: addScalarDependencies,
  equalScalarDependencies: equalScalarDependencies,
  createSpaClass: createSpaClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSpaClass.generated.js
// module id = 525
// module chunks = 0